import React from "react";
import "./MembershipPage.css"
const MembershipHead = () => {
  return (
    <div className="membershipHeadContainer">
      <h1>Membership</h1>
      <div className="membershipUnderline"></div>
    </div>
  );
};

export default MembershipHead;
